export default "__VITE_ASSET__xC_Fw5kQ__"